export const config = {
  NODE_ENV: process.env.NODE_ENV,
  INVOICE_PAGE_SIZE: parseInt(process.env.REACT_APP_INVOICE_PAGE_SIZE ?? 1),
  EXPENSE_PAGE_SIZE: parseInt(process.env.REACT_APP_EXPENSE_PAGE_SIZE ?? 1),
  INACTIVITY_TIME: parseInt(process.env.REACT_APP_INACTIVITY_TIME ?? 3600),
  API_URL: process.env.REACT_APP_API_URL,
  PDF_URL: process.env.REACT_APP_PDF_LINK,
  GOOGLE_MAPS_API_URL: process.env.REACT_APP_GOOGLE_MAPS_API_URL,
};
